import { FormattedMessage } from 'react-intl';
import Spinner from 'react-bootstrap/Spinner';
import CONSTANTS from '../utils/constants';

export const PaymentProcessingLoader: React.FC = () => {
  return (
    <div className='d-flex processing-widget widget-wrapper'>
      <Spinner className='processing-spinner' role='status' data-testid='pm-paymentProcessing-spinner'>
        <span className="visually-hidden" data-testid='pm-paymentProcessing-loading-text'>
          <FormattedMessage id={CONSTANTS.LOADING.LOADING_TEXT} defaultMessage="Loading..." />
        </span>
      </Spinner>
      <div className='d-flex flex-column widget-text'>
        <h5 className='volte-semibold widget-heading' data-testid='pm-widget-primary-text'>
          <FormattedMessage id={CONSTANTS.PAYMENT_PROCESSING.PRIMARY_MESSAGE} defaultMessage="Payment request is being processed" />
        </h5>
        <p className='volte-medium widget-sub-heading' data-testid='pm-widget-secondary-text'>
          <FormattedMessage id={CONSTANTS.PAYMENT_PROCESSING.SECONDARY_MESSAGE} defaultMessage="It may take a few seconds until it is processed." />
        </p>
      </div>
    </div>
  )
}